import * as React from 'react';

import classNames from 'classnames';

const ERPPriceOriginDotMark = ({
	price,
	userDefined,
	tooltipSide,
}: {
	price: string | number | undefined | null;
	userDefined: boolean;
	tooltipSide?: 'left' | 'right';
}) => {
	const hasPrice = !(price == null || typeof price === 'undefined' || price === '');

	return (
		<span
			className={classNames('relative flex-none w-2 h-2 mr-1.5 grow-0 shrink-0 rounded-full group z-10', {
				'bg-green-500': hasPrice && !userDefined,
				'bg-yellow-500': hasPrice && userDefined,
				'bg-red-500': !hasPrice,
			})}
		>
			<span
				className={classNames(
					'absolute -bottom-1 -mb-0.5 px-1.5 py-1 rounded-sm font-display text-labelsmall text-white bg-black text-center whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible',
					{
						'mr-1 right-full': tooltipSide === 'left',
						'ml-1 left-full': tooltipSide === 'right' || !tooltipSide,
					}
				)}
			>
				{hasPrice && !userDefined && <>Settings from Price Monitor database</>}
				{hasPrice && userDefined && <>Settings input from user, not Price monitor</>}

				{!hasPrice && <>No price available from the Price Monitor database</>}
			</span>
		</span>
	);
};

export default React.memo(ERPPriceOriginDotMark);
